/* globals iban Stripe wcv_sc_params StripeCheckout */

jQuery(function($) {
	'use strict';

	try {
		var stripe = Stripe(wcv_sc_params.key);
	} catch (error) {
		// eslint-disable-next-line
		console.log(error);
		return;
	}

	var stripe_elements_options = Object.keys(wcv_sc_params.elements_options)
			.length
			? wcv_sc_params.elements_options
			: {},
		elements = stripe.elements(stripe_elements_options),
		stripe_card,
		stripe_exp,
		stripe_cvc;

	/**
	 * Object to handle Stripe elements payment form.
	 */
	var wcv_stripe_connect_form = {
		/**
		 * Initialize event handlers and UI state.
		 */
		init: function() {
			// if ( 'yes' === wcv_sc_params.is_change_payment_page || 'yes' === wcv_sc_params.is_pay_for_order_page ) {
			// 	$( document.body ).trigger( 'wc-credit-card-form-init' );
			// }

			// Stripe Checkout.
			this.stripe_checkout_submit = false;

			// checkout page
			if ($('form.woocommerce-checkout').length) {
				this.form = $('form.woocommerce-checkout');
			}

			$('form.woocommerce-checkout').on(
				'checkout_place_order_stripe-connect',
				this.onSubmit
			);

			// pay order page
			if ($('form#order_review').length) {
				this.form = $('form#order_review');
			}

			$('form#order_review, form#add_payment_method').on(
				'submit',
				this.onSubmit
			);

			// add payment method page
			if ($('form#add_payment_method').length) {
				this.form = $('form#add_payment_method');
			}

			$('form.woocommerce-checkout').on('change', this.reset);

			$(document)
				.on('stripeConnectError', this.onError)
				.on('checkout_error', this.reset);

			wcv_stripe_connect_form.createElements();

			window.addEventListener(
				'hashchange',
				wcv_stripe_connect_form.onHashChange
			);

			// Stripe Checkout
			if ('yes' === wcv_sc_params.is_stripe_checkout) {
				$(document.body).on('click', '#place_order', function() {
					if (!wcv_stripe_connect_form.isStripeCardChosen()) {
						return;
					}

					wcv_stripe_connect_form.openModal();
					return false;
				});
			}
		},

		unmountElements: function() {
			stripe_card.unmount('#stripe-connect-card-element');
			stripe_exp.unmount('#stripe-connect-exp-element');
			stripe_cvc.unmount('#stripe-connect-cvc-element');
		},

		mountElements: function() {
			if (!$('#stripe-connect-card-element').length) {
				return;
			}

			stripe_card.mount('#stripe-connect-card-element');
			stripe_exp.mount('#stripe-connect-exp-element');
			stripe_cvc.mount('#stripe-connect-cvc-element');
		},

		createElements: function() {
			var elementStyles = {
				base: {
					iconColor: '#666EE8',
					color: '#31325F',
					fontSize: '15px',
					'::placeholder': {
						color: '#CFD7E0'
					}
				}
			};

			var elementClasses = {
				focus: 'focused',
				empty: 'empty',
				invalid: 'invalid'
			};

			stripe_card = elements.create('cardNumber', {
				style: elementStyles,
				classes: elementClasses
			});
			stripe_exp = elements.create('cardExpiry', {
				style: elementStyles,
				classes: elementClasses
			});
			stripe_cvc = elements.create('cardCvc', {
				style: elementStyles,
				classes: elementClasses
			});

			stripe_card.addEventListener('change', function(event) {
				wcv_stripe_connect_form.onCCFormChange();

				wcv_stripe_connect_form.updateCardBrand(event.brand);
				$('input.stripe-connect-source').remove();

				if (event.error) {
					$(document.body).trigger('stripeConnectError', event);
				}
			});

			stripe_exp.addEventListener('change', function(event) {
				wcv_stripe_connect_form.onCCFormChange();
				$('input.stripe-connect-source').remove();

				if (event.error) {
					$(document.body).trigger('stripeConnectError', event);
				}
			});

			stripe_cvc.addEventListener('change', function(event) {
				wcv_stripe_connect_form.onCCFormChange();
				$('input.stripe-connect-source').remove();

				if (event.error) {
					$(document.body).trigger('stripeConnectError', event);
				}
			});

			/**
			 * Only in checkout page we need to delay the mounting of the
			 * card as some AJAX process needs to happen before we do.
			 */
			if ('yes' === wcv_sc_params.is_checkout) {
				$(document.body).on('updated_checkout', function() {
					// Don't mount elements a second time.
					if (stripe_card) {
						wcv_stripe_connect_form.unmountElements();
					}

					wcv_stripe_connect_form.mountElements();

					if ($('#stripe-iban-element').length) {
						iban.mount('#stripe-iban-element');
					}
				});
			} else if (
				$('form#add_payment_method').length ||
				$('form#order_review').length
			) {
				wcv_stripe_connect_form.mountElements();

				if ($('#stripe-iban-element').length) {
					iban.mount('#stripe-iban-element');
				}
			}
		},

		onCCFormChange: function() {
			wcv_stripe_connect_form.reset();
		},

		updateCardBrand: function(brand) {
			var brandClass = {
				visa: 'stripe-visa-brand',
				mastercard: 'stripe-mastercard-brand',
				amex: 'stripe-amex-brand',
				discover: 'stripe-discover-brand',
				diners: 'stripe-diners-brand',
				jcb: 'stripe-jcb-brand',
				unknown: 'stripe-credit-card-brand'
			};

			var imageElement = $('.stripe-card-brand'),
				imageClass = 'stripe-credit-card-brand';

			if (brand in brandClass) {
				imageClass = brandClass[brand];
			}

			// Remove existing card brand class.
			$.each(brandClass, function(index, el) {
				imageElement.removeClass(el);
			});

			imageElement.addClass(imageClass);
		},

		// Stripe Checkout.
		openModal: function() {
			// Capture submittal and open stripecheckout
			var $form = wcv_stripe_connect_form.form,
				$data = $('#stripe-connect-payment-data');

			wcv_stripe_connect_form.reset();

			var token_action = function(res) {
				$form.find('input.stripe_source').remove();

				if ('token' === res.object) {
					stripe
						.createSource({
							type: 'card',
							token: res.id
						})
						.then(wcv_stripe_connect_form.sourceResponse);
				} else if ('source' === res.object) {
					var response = { source: res };
					wcv_stripe_connect_form.sourceResponse(response);
				}
			};

			StripeCheckout.open({
				key: wcv_sc_params.key,
				billingAddress: $data.data('billing-address'),
				zipCode: $data.data('verify-zip'),
				amount: $data.data('amount'),
				name: $data.data('name'),
				description: $data.data('description'),
				currency: $data.data('currency'),
				image: $data.data('image'),
				locale: $data.data('locale'),
				email: $('#billing_email').val() || $data.data('email'),
				panelLabel: $data.data('panel-label'),
				allowRememberMe: $data.data('allow-remember-me'),
				token: token_action,
				closed: wcv_stripe_connect_form.onClose()
			});
		},

		// Stripe Checkout.
		resetModal: function() {
			wcv_stripe_connect_form.reset();
			wcv_stripe_connect_form.stripe_checkout_submit = false;
		},

		// Stripe Checkout.
		onClose: function() {
			wcv_stripe_connect_form.unblock();
		},

		unblock: function() {
			wcv_stripe_connect_form.form.unblock();
		},

		// rest
		reset: function() {
			$(
				'.wcv-stripe-connect-error, .stripeConnectError, .stripe_connect_token'
			).remove();

			// Stripe Checkout.
			if ('yes' === wcv_sc_params.is_stripe_checkout) {
				wcv_stripe_connect_form.stripe_submit = false;
			}
		},

		// Check to see if Stripe in general is being used for checkout.
		isStripeConnectChosen: function() {
			return (
				$('#payment_method_stripe-connect').is(':checked') ||
				($('#payment_method_stripe-connect').is(':checked') &&
					'new' ===
						$(
							'input[name="wc-stripe-payment-token"]:checked'
						).val())
			);
		},

		// Currently only support saved cards via credit cards and SEPA. No other payment method.
		isStripeSaveCardChosen: function() {
			return (
				$('#payment_method_stripe-connect').is(':checked') &&
				$('input[name="wc-stripe-connect-payment-token"]').is(
					':checked'
				) &&
				'new' !==
					$(
						'input[name="wc-stripe-connect-payment-token"]:checked'
					).val()
			);
		},

		// Stripe credit card used.
		isStripeCardChosen: function() {
			return $('#payment_method_stripe-connect').is(':checked');
		},

		hasSource: function() {
			return 0 < $('input.stripe-connect-source').length;
		},

		// Legacy
		hasToken: function() {
			return 0 < $('input.stripe_connect_token').length;
		},

		isMobile: function() {
			if (
				/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				)
			) {
				return true;
			}

			return false;
		},

		isStripeModalNeeded: function() {
			var token = wcv_stripe_connect_form.form.find(
				'input.stripe_connect_token'
			);

			// If this is a stripe submission (after modal) and token exists, allow submit.
			if (wcv_stripe_connect_form.stripe_submit && token) {
				return false;
			}

			// Don't affect submission if modal is not needed.
			if (!wcv_stripe_connect_form.isStripeConnectChosen()) {
				return false;
			}

			return true;
		},

		block: function() {
			if (!wcv_stripe_connect_form.isMobile()) {
				wcv_stripe_connect_form.form.block({
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6
					}
				});
			}
		},

		// Get the customer details
		getCustomerDetails: function() {
			var first_name = $('#billing_first_name').length
					? $('#billing_first_name').val()
					: wcv_sc_params.billing_first_name,
				last_name = $('#billing_last_name').length
					? $('#billing_last_name').val()
					: wcv_sc_params.billing_last_name,
				extra_details = {
					owner: { name: '', address: {}, email: '', phone: '' }
				};

			extra_details.owner.name = first_name;

			if (first_name && last_name) {
				extra_details.owner.name = first_name + ' ' + last_name;
			} else {
				extra_details.owner.name = $('#stripe-payment-data').data(
					'full-name'
				);
			}

			extra_details.owner.email = $('#billing_email').val();
			extra_details.owner.phone = $('#billing_phone').val();

			/* Stripe does not like empty string values so
			 * we need to remove the parameter if we're not
			 * passing any value.
			 */
			if (
				'undefined' === typeof extra_details.owner.phone ||
				0 >= extra_details.owner.phone.length
			) {
				delete extra_details.owner.phone;
			}

			if (
				'undefined' === typeof extra_details.owner.email ||
				0 >= extra_details.owner.email.length
			) {
				if ($('#stripe-connect-payment-data').data('email').length) {
					extra_details.owner.email = $(
						'#stripe-connect-payment-data'
					).data('email');
				} else {
					delete extra_details.owner.email;
				}
			}

			if (
				'undefined' === typeof extra_details.owner.name ||
				0 >= extra_details.owner.name.length
			) {
				delete extra_details.owner.name;
			}

			if (0 < $('#billing_address_1').length) {
				extra_details.owner.address.line1 = $(
					'#billing_address_1'
				).val();
				extra_details.owner.address.line2 = $(
					'#billing_address_2'
				).val();
				extra_details.owner.address.state = $('#billing_state').val();
				extra_details.owner.address.city = $('#billing_city').val();
				extra_details.owner.address.postal_code = $(
					'#billing_postcode'
				).val();
				extra_details.owner.address.country = $(
					'#billing_country'
				).val();
			} else if (wcv_sc_params.billing_address_1) {
				extra_details.owner.address.line1 =
					wcv_sc_params.billing_address_1;
				extra_details.owner.address.line2 =
					wcv_sc_params.billing_address_2;
				extra_details.owner.address.state = wcv_sc_params.billing_state;
				extra_details.owner.address.city = wcv_sc_params.billing_city;
				extra_details.owner.address.postal_code =
					wcv_sc_params.billing_postcode;
				extra_details.owner.address.country =
					wcv_sc_params.billing_country;
			}

			return extra_details;
		},

		// Source Support
		createSource: function() {
			var extra_details = wcv_stripe_connect_form.getCustomerDetails();

			// Create the Stripe source
			stripe
				.createSource(stripe_card, extra_details)
				.then(wcv_stripe_connect_form.sourceResponse);
		},

		sourceResponse: function(response) {
			if (response.error) {
				$(document.body).trigger('stripeConnectError', response);
			} else if (
				'no' === wcv_sc_params.allow_prepaid_card &&
				'card' === response.source.type &&
				'prepaid' === response.source.card.funding
			) {
				response.error = { message: wcv_sc_params.no_prepaid_card_msg };

				if ('yes' === wcv_sc_params.is_stripe_checkout) {
					wcv_stripe_connect_form.submitError(
						'<ul class="woocommerce-error"><li>' +
							wcv_sc_params.no_prepaid_card_msg +
							'</li></ul>'
					);
				} else {
					$(document.body).trigger('stripeConnectError', response);
				}
			} else {
				wcv_stripe_connect_form.processStripeResponse(response.source);
			}
		},

		processStripeResponse: function(source) {
			wcv_stripe_connect_form.reset();

			// Insert the Source into the form so it gets submitted to the server.
			wcv_stripe_connect_form.form.append(
				"<input type='hidden' class='stripe-connect-source' name='stripe_connect_source' value='" +
					source.id +
					"'/>"
			);

			if ($('form#add_payment_method').length) {
				$(wcv_stripe_connect_form.form).off(
					'submit',
					wcv_stripe_connect_form.form.onSubmit
				);
			}

			wcv_stripe_connect_form.form.submit();
		},

		onSubmit: function(e) {
			if (!wcv_stripe_connect_form.isStripeConnectChosen()) {
				return;
			}

			if (
				!wcv_stripe_connect_form.isStripeSaveCardChosen() &&
				!wcv_stripe_connect_form.hasSource() &&
				!wcv_stripe_connect_form.hasToken()
			) {
				e.preventDefault();

				wcv_stripe_connect_form.block();

				// Stripe Checkout.
				if (
					'yes' === wcv_sc_params.is_stripe_checkout &&
					wcv_stripe_connect_form.isStripeModalNeeded() &&
					wcv_stripe_connect_form.isStripeCardChosen()
				) {
					if ('yes' === wcv_sc_params.is_checkout) {
						return true;
					} else {
						wcv_stripe_connect_form.openModal();
						return false;
					}
				}

				wcv_stripe_connect_form.createSource();

				// Prevent form submitting
				return false;
			}
		},

		getSelectedPaymentElement: function() {
			return $('.payment_methods input[name="payment_method"]:checked');
		},

		onError: function(e, result) {
			var message = result.error.message;
			var selectedMethodElement = wcv_stripe_connect_form
				.getSelectedPaymentElement()
				.closest('li');
			var savedTokens = selectedMethodElement.find(
				'.woocommerce-SavedPaymentMethods-tokenInput'
			);
			var errorContainer;

			if (savedTokens.length) {
				// In case there are saved cards too, display the message next to the correct one.
				var selectedToken = savedTokens.filter(':checked');

				if (
					selectedToken.closest(
						'.woocommerce-SavedPaymentMethods-new'
					).length
				) {
					// Display the error next to the CC fields if a new card is being entered.
					errorContainer = $(
						'#wcv-stripe-connect-cc-form .stripe-connect-source-errors'
					);
				} else {
					// Display the error next to the chosen saved card.
					errorContainer = selectedToken
						.closest('li')
						.find('.stripe-connect-source-errors');
				}
			} else {
				// When no saved cards are available, display the error next to CC fields.
				errorContainer = selectedMethodElement.find(
					'.stripe-connect-source-errors'
				);
			}

			/*
			 * Customers do not need to know the specifics of the below type of errors
			 * therefore return a generic localizable error message.
			 */
			if (
				'invalid_request_error' === result.error.type ||
				'api_connection_error' === result.error.type ||
				'api_error' === result.error.type ||
				'authentication_error' === result.error.type ||
				'rate_limit_error' === result.error.type
			) {
				message = wcv_sc_params.invalid_request_error;
			}

			if (
				'card_error' === result.error.type &&
				wcv_sc_params.hasOwnProperty(result.error.code)
			) {
				message = wcv_sc_params[result.error.code];
			}

			if (
				'validation_error' === result.error.type &&
				wcv_sc_params.hasOwnProperty(result.error.code)
			) {
				message = wcv_sc_params[result.error.code];
			}

			wcv_stripe_connect_form.reset();
			$('.woocommerce-NoticeGroup-checkout').remove();
			// eslint-disable-next-line
			console.log(result.error.message); // Leave for troubleshooting.
			errorContainer.html(
				'<ul class="woocommerce_error woocommerce-error wcv-stripe-connect-error"><li>' +
					message +
					'</li></ul>'
			);

			if ($('.wcv-stripe-connect-error').length) {
				$('html, body').animate(
					{
						scrollTop:
							$('.wcv-stripe-connect-error').offset().top - 200
					},
					200
				);
			}
			wcv_stripe_connect_form.unblock();
		},

		submitError: function(error_message) {
			$(
				'.woocommerce-NoticeGroup-checkout, .woocommerce-error, .woocommerce-message'
			).remove();
			wcv_stripe_connect_form.form.prepend(
				'<div class="woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout">' +
					error_message +
					'</div>'
			);
			wcv_stripe_connect_form.form.removeClass('processing').unblock();
			wcv_stripe_connect_form.form
				.find('.input-text, select, input:checkbox')
				.blur();

			var selector = '';

			if ($('#add_payment_method').length) {
				selector = $('#add_payment_method');
			}

			if ($('#order_review').length) {
				selector = $('#order_review');
			}

			if ($('form.checkout').length) {
				selector = $('form.checkout');
			}

			if (selector.length) {
				$('html, body').animate(
					{
						scrollTop: selector.offset().top - 100
					},
					500
				);
			}

			$(document.body).trigger('checkout_error');
			wcv_stripe_connect_form.unblock();
		},

		/**
		 * Handles changes in the hash in order to show a modal for PaymentIntent confirmations.
		 *
		 * Listens for `hashchange` events and checks for a hash in the following format:
		 * #confirm-pi-<intentClientSecret>:<successRedirectURL>
		 *
		 * If such a hash appears, the partials will be used to call `stripe.handleCardAction`
		 * in order to allow customers to confirm an 3DS/SCA authorization.
		 *
		 * Those redirects/hashes are generated in `WCV_SC_Payment_Gateway::generate_charges_transfers_payment`.
		 */
		onHashChange: function() {
			var partials = window.location.hash.match(
				/^#?confirm-pi-([^:]+):(.+)$/
			);

			if (!partials || 3 > partials.length) {
				return;
			}

			var intentClientSecret = partials[1];
			var redirectURL = decodeURIComponent(partials[2]);

			// Cleanup the URL
			window.location.hash = '';

			wcv_stripe_connect_form.openIntentModal(
				intentClientSecret,
				redirectURL
			);
		},

		/**
		 * Opens the modal for PaymentIntent authorizations.
		 *
		 * @param {string}  intentClientSecret The client secret of the intent.
		 * @param {string}  redirectURL        The URL to ping on fail or redirect to on success.
		 * @param {boolean} alwaysRedirect     If set to true, an immediate redirect will happen no matter the result.
		 *                                     If not, an error will be displayed on failure.
		 */
		openIntentModal: function(
			intentClientSecret,
			redirectURL,
			alwaysRedirect
		) {
			stripe
				.handleCardAction(intentClientSecret)
				.then(function(response) {
					if (response.error) {
						throw response.error;
					}

					if (
						'requires_confirmation' !==
						response.paymentIntent.status
					) {
						return;
					}

					window.location = redirectURL;
				})
				.catch(function(error) {
					if (alwaysRedirect) {
						return (window.location = redirectURL);
					}

					$(document.body).trigger('stripeConnectError', {
						error: error
					});
					wcv_stripe_connect_form.form.removeClass('processing');

					// Report back to the server.
					$.get(redirectURL + '&is_ajax');
				});
		}
	};

	wcv_stripe_connect_form.init();
});
